<template>

<div>
<div class="foot-updated" v-if="item.page"><div class="inner">Page last updated on {{ item.page.updated | localDatee('Do MMMM, YYYY') }}</div></div>

<div class="foot">

    <div class="foot-inner inner">

        <div class="foot-logo is-parish" />

        <div class="foot-people" v-html="$nl2br(item.site.settings.foot_people)" />

        <div class="foot-address">

            <div class="foot-address-item" v-html="$nl2br(item.site.settings.foot_address_1)" />

            <div class="foot-address-item" v-html="$nl2br(item.site.settings.foot_address_2)" />

        </div>

        <div class="foot-logo is-coe" />

        <div class="foot-contact">

            <div class="foot-contact-item is-phone">{{ item.site.settings.foot_phone }}</div>

            <div class="foot-contact-item is-email">{{ item.site.settings.foot_email }}</div>

        </div>

        <div class="foot-links">

            <router-link v-for="(link, index) in item.site.settings.foot_links" :to="{ path: link.url }" :key="index" class="foot-links-item">{{ link.name }}</router-link>
        
        </div>

        <div class="foot-legal" v-html="$nl2br(item.site.settings.foot_legal)" />

    </div>

</div>
</div>

</template>

<script>

export default {

    props: ['item']

}

</script>

<style scoped>

.foot {
    background-color: #fff;
    border-top: 2px solid #F0C994;
}

.foot-inner {
    display: grid;
    padding: 100px 10px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
}

.is-tablet .foot-inner {
    grid-column-gap: 40px;
    padding: 64px 10px;
}

.is-mobile .foot-inner {
    padding: 40px 10px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
}

.foot-logo.is-parish {
    background-size: auto 68px;
    height: 68px;
    background-position: 0px 0px;
    background-repeat: no-repeat;
    order: 1;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAaYAAACKCAYAAADhaO76AAAABHNCSVQICAgIfAhkiAAAIABJREFUeF7tXT1zG0mSrQYUMZQ1o18wHOfck9wNgUe564hyTtAaJ8g6c6g448zheOuNZJ41kLOizhkq7iLOFCTo1hX1Cwb6BSNas3shoC+zmyDxUZX10VWNbuB1BKXRsLo+XlbXq8zKysxUG56HvfvUzUOVqdsqp59MfUN/f6a/z+nvc9WdvlB/+et5G4aCPgIBIAAEgICMQNZYgAaH36i/ffleqWxAfdx36OdEZdmJevnuhUNZFAECQAAIAIGGItA8YuofEglNfyBN6KjQjPwfEJQ/ZngDCAABINAYBJpDTHNCUoo1pBjPRKl8qPZuPFfD0ecYFaIOIAAEgAAQSI/A5okpjJDeEjT/5AQPn0V1smOY+JzQQiEgAASAwMYR2BwxXZ8hnTiiQGdH3RN1OiJN6PL50x9uq1n3mP712FpHnp2rbPZUnb4fWcuiABAAAkAACGwMgc0Q06PeEZ0h/USj3ncYOWlH3cESIa2+VGpdTHAOBKXOVNYlglogOIdOoAgQAAJAAAjUg0C9xFQSyM80tEOH4X0i5wcywY3PHMqWRXwISuWkfb3/0bluFAQCQAAIAIFaEKiPmB4ekOs3kYGTp132o9rrPAt2WnAlKDbvdb88wR2oWuYaGgECQAAIOCGQnpj4LOl30pIycv+2P6/JbHcczczWv0uaGd1tsjpKQHuyiwYlgAAQAAL1IJCWmJgY8uwXBy3pE2lTdI6UyDGh3xsQnM/o52sjrIVzROdBNFKsR35oBQgAASCwdQikI6b+3R8utRUJtAsiLYrWMGbSSPsUXoDTITXC4Y30TxnmiBwjxlwODxAAAkAACGwAgfjE5G66e632uoPgc6RQsEqPQCYes/YEx4hQdPEeEAACQKAyAnGJiZ0O8hmZ7vLbQs9YSxp4edtVHuZKBW7a05m62X1SO3HGHivqAwJAAAi0DIF4xMSXXafdN5bzpM1oSSahlGdP7L6uf3Du1LLpjO4CASCwDQjEISY7KV0QWORt18CzmzJ6BN+V+lYrUD536k7vwaV8G6Y7xgAEgEAbEKhOTHxmMyOtw3w/6SO5gB812tutNO0xOenj74Gc2jCX0UcgAAS2BIFqxGQzhSn1ghwcjltzTtPvDUmu+rBGIKctmfIYBhAAAk1HIJyYysurb4QBPmmk6c4mkf7BCd2pIld3zQNysqGH3wMBIAAEKiMQRkzymRKdJ+Vkukt0WbbykB0qkDRBkJMDgCgCBIAAEAhHwJ+YbKTUmR5uhaOAjZxudr9rjYkyfH7gTSAABIBA7Qj4EVN5efZXg6PDJ9WZHm0FKc3FIJIThTC62bkHcqp9zqJBIAAEthwBP2J6ePDBcHn2Izk5HG7lIi07eAzpHO3Jls8RDA8IAAEgUCsC7sTU7/FF1IGmdxdESvtbSUpXmpPgEKEoRcfpu5NapYbGgAAQAAJbjIAbMZm1hgsy323HmZJNyJIreaYebDTEkq3v+D0QAAJAoEUI2ImpjIzwQasp7QopXZ85jeg/1y/hsqcenCFaNO3RVSAABJqMgExMZUQEJqV9zSDaeU+pijRKPM6pivXwRbk6U6/GD6pUj3eBABAAAkCAbsiKIDy6+4wS/VFK9NVnh89VzBoko/m0ltxSmLlAAAgAgS1GwExM5sgOb8kT7XCLMbEPzXTmViQa7N5pdFxA++hQAggAASCwUQQEYur9qjHhbb8Hnqs4+j0O+qrLhjsi4r7nWg3KAQEgAASAwDICemIyxYury/vs0cFjleeDIGEVWkv+PHlIpPK8aUJ9XM+EWxdOQQDhJSAABIBAsxFYJyZzdIfXpAkcJR9Omfr8l0rt1OUlZ+7rhLD6rtIY8DIQAAJAYEcRWCcmvbZUnwlPiu7tJaT8XnKtiftjMunBEcJLWigMBIAAEJgjsExMRm2pRi+8fm9EndMn7POSW13EdLivVOFCvmzSq0tr88IEhYEAEAACzUdgmZg2rS2VGki7iKnosylkUY2E3vy5hh4CASAABJwQWCEmrSdevRdpdcR0Os5U4b5ueLLsNp1L/bT825o0Jm5UcoTY697a6jiCTtMMhYAAEAAC7ghcE5P+IL++s6V5n03EJI1Je+eqRmKC1uQ+41ASCAABIGBB4JqYdEFK2e365fvjWlFsKzGVWtNvGqzgoVfrBEJjQAAItB2BRWLK1wdDWVpPR5NaB9lWYiq0JsOl2870zlYlUKx1QqAxIAAEdg2Bkpj0ZryPdBfndu2AtJuYBoQX561aeeAEUfs8QoNAAAi0FoFLYtIEa92EGa/UOkb057K7ODs/SE8Tzpi4f2ZzHuILtvYTQceBABCoG4Fywe/rvPFqdh6Yj7zNxFRiyXea/nFNkDZyrVvyaA8IAAEg0FAEMuMuf1MLaduJyZgqZAPndQ2ddOgWEAACQEBC4PJ+UPZmpdDmTE9tJyZjGvoNaaCY/0AACACBliFAxKSNWvCCHB8GGxlL64mJLwKvET1BCWLayHxCo0AACLQOgUxpTU8b9CJrOzGV50wa1/sNYtq6aYkOAwEgsMsIkMak8YLbZGRsENMuz0eMHQgAASCg9MS0SbPTdhDTiObWSoR0aEz43oAAEAACLggwMWnMThs8DwExucgNZYAAEAACW4sAiCmFaLWpO6AxpYAadQIBILB9CICYUsgUxJQCVdQJBIDAjiAAYkohaBBTClRRJxAAAjuCAIgphaBBTHpUOZbg36fr4Zq49Mvx2xSiEOt81FtxULks/VX3I5I7RpBG/3BfZdNv12rahKwjDAdV1IdAODE9Onis8tl+/K5mA6pzuV5beCRtEFc1pEutk/j9UxQV4/1IrHdTxFRGnXicYMxcJV+6Jkw9noKIZvfVLD+itw7JB/Qby9sjykR8rrrTF0nShPzpD7fVtPuY+sH9sc1dnjvcnzP1avzaY9R8j80sh870afSxNUXuc3nn+SHhdiTKO884puRQ3ey88NoEsAxn3ZVs1VfS8Z+ji4Lt91Yj4JS/zfKPlfPSMUmrqSbzwGUHYrTBVZVrz7pDW6z6Vz+ERO2FEdPDgw8krPpSYoQRk9da4lfY4siwMWLSRvHwG5qxtIfzRhFl/cv3Ks+OHchI3yIvXNnsqXUT4DK6YhOVnziQkam2CY3lmXr17rlLc4ZoKpevJvB41UdvceqqvZCj3BnjWf7MW965+kwr/4k7tqbIKgWD/KhO37Gcwx6th3JRVfUQbY96x0QXJkK97G+EeJopx6BDNVF7/sSk107CJoLrW00jJv6YXo1vGbu/y8RU7mh/qUACq7AO1V73qdeuel4DE+TvtEstNaTqD5Nl98sTq8YjEsUWElO/x5rAoCLAI5LzA6ucxfWnwcSkzeCwgliMwAaJiEJY6zTXjaqTeRuIyS1hoVkgFb8Xw+sSWe4qMRkD2FYUARPCzc4966K12ExptnvjvYO3dZU3Jd3pPZGcdomY4pDSHPURmYvviSJoIzGVm7UPtqlFWvk5aY53rOWkAiCmSvD5vPzE6WxDSwY+zXiWBTEtA5aKlOat+JBTKlK66ouFnHaFmFLI3JagtI3EZEyFo1lzOtM7Vo0cxKRBQD8xXpB9d+K5tMvFs/wzefSMvIRUpIjPEpx95WymWPYuah8xfaQxkD0/+BkaNwgF7orNd67Pogfe/hq2plpKR4QHYiOl+e5XD01pERd2ztB7Da43OiHT0x2tFtcsYkond7t5itrOzug8mh0dSM75Pn2f/C19LcpQWpzbSEwPe785z0cbMdu+sN3VmHQH7Ans5jYB1Pl73zBJjTTlJZKRKxHwB5fNhtqNRulGPiByO7EuWpl6QK7lZ0bxl55Vh5bp8ZYWimfGekpNgH/07uTXlevTwzSKmBLJ3bYZMZ2XFI4x02cEoeQ9ak670zZisuGk2/Ccjr8LXt5ATIvQJZr8wdKJ/CKIyQxovze0LDK0a+4eqdPRxCoVt0VrQpqb/sO1m5YuiJAGIrEtdjLUk2oXiEn2BLR7sfV7rEXptVPJuahtxGT/PtY/C9vmS/qQQEwgJmHXPlrfbVf0GLKu6lSg7gXRfqj7kcxdh15OCzxO63mhYSMkm5YuVGd66GUaLvpiccHXmV7qlkPd7Vll5DDXbZrEXveW3kzaInfxcqP1m+HT5btx9w2/C0/UCmICMe08Mcm7wQsipX1vUioWveIy4q8CF69/uLaFrtouVLPRuOrdugZXN1HU3Z6VmJTdYalctM0m2c70WLuJaJPGJGnwfI42655oyYk1xpt0p2k48j8TBjGBmHaemORDXfviJJskhvRr0zmEhgx6vMjF34FyH22kp1YuRtZNFHW3ZyOmqgf44rxokcZkPu/8RObo/csIIaZoEGHfD4gJxLTTxCQv1uWHV+Upd8a8o9Q/e3RutbijlO6xVXXBte3uFUWVWAxTVTdR1N1eSUzmjYPLXa/QudEWjUnS+heJu99jrUjnpfiaviH/i+E7S0zaA2E4Pyx9Z7vglSfdzUi5Y9YtaHI0ErcL2qELpbY/0rlUgm9lM8Q0oKGbY78xOWX5gyghpRYxbgsxSY4zixsl0RweEKJoZ4lJOzESfGwxF4qqdcErbx1B0UGh5vkgLswOB/FV58fq+3UTRd3t8XhLLXJi2O0vIjJSWTZUL9/RXccIT1uIyeyIs2xNkCwPISGKQEyLk6zmhSjC/PaqYhuIiQOqdoqLjv6PLk2BdL5ki23o3wP5DWnXWcXpIbSfdROF1F5suS9pLx5BgwsNii5Ih0Rrd9aYKFp5xlkFAp+cosnrH7v7++J7oreqZqNkMueFhCgCMS1Iosrkl+aQb94WU/6XwHl69dqMIkuvRlNvX+SHcBR0YzV/ABdkG7eltwjvi+7NJmlv3L8mEVMVpF02GH3R6UTfehFRnAgkJL3JJoJI+0YX9zXPSeV9z0dBTFVmvPO7E7p78sDp7olPPCrn5oWCIKYkUYWDRCMRk8viGtSo8NIuEVNBxNZL1hLCpKXklK7CkuNsXkMbiMlsTdCfd4rmPIqY8vL9sfMUBTE5Q1W1oJt3CqKL2y+DhkpidXGX7xn5mT1C+7T4HojphBb3H2JAuVSHD6mXiyuHGlrPWOvSMTbx3ew+sd7daToxhZ4Z9XsTA3bmSCd660G9G8ZERNj8tBe23EcsHHsEApdPw68MNKZ6PwBJOhIxmSII+Enbr/SuaUzLm4QB/ZN3+K7BcK/fdnEzbzoxiaZNwctO9HK1xIdcxr/e77IxxOTujeP3MUulbTu3+ierHDKkke7iFcThd8ak6Iwpq9Ca/6s4Y9q8xrQqNd4s5h0KzJvxXRx3LcpGTvV/6zwyNyuAHIJIvrYgb67dQxQlIgrjR5moPX+NiXtYmHJmtDMq0qvHPujmOpcvnNkWOv1k/UT1TPxXOeGNInw/pff4qjsUTQ6NJKbInpOS6dQmr6hC4fnYG9Gfhkjgkcft0vdGaUwbGL+ZpFibklNe8LuSN1qT3cXlIML2SA4mc55PiKJERNEOYnL5OEPL+LpmF0SpC1Oygfsr8zHvBjGZo0OvhugJnQuu70lEEHIXxLVdUzkQkxnBcvHmsygbQekX8iYT08ODD2veu3MkXEzKsgOXndiKtbC3o6a8qh+t7X0Qkw0h4aOvMeKAZEuvmwzk9BRuzjPhqK+/CWKS0SxNXkMqZIptyO/r5dZUYrIHHq46w+xp50FMVTEW3gcxhYNb54LYJDKwLQouu9Vw1EFModiF5GRqLDF5XDYOxcvFEgGNKRhd+UUQUziwdRKT1RMyIM7X4shLt9vvjWCcju8t/c7sbsvF3MwgpsbKHb6QOn7lHk6dcih2yTVqykV7dMacTfUODXmXQu44JIXkemxR27VONw2NLm5PMx/+Xc/fdLFEgJiq46ytAcQUDmztC5Tx7gUdYNO9lFfjB8GDkVOkr3s4yfb5CeWGumO9I2PqrDUz7o6lvaiavXaOs03TbQsxWTdpwV/B6ov2O00gpmhgL1cEYgoHtn5iGlBnzRGmQzUVm0uwNmusNbngkNzYn3iDW2pLH+i9fcO76yk+apdD3RpT4cCgl7vLvcM5kLYFvS3EVC3yhd+UtIUoAjH54elcGsTkDNVawboXxHLRZu886Z6KnxmNF6tp9w0F4xSuIRjMhPYFwo+ceHy/T3+mvkh5cdbHV7cc6m7PRiguJqfCJCgQnOnuUBPPmMwhiC7IdOCfU4nnW57pzdi2lDIgpvD1U3wTxBQObN0LlH1xKcfCoWpudn+0mtIeHTxWs5wC5op348xedqVpiIlSckUeUfzFp9b4iwVB3iBSKu7qmR59+vi65VB3e6XcJ/KGxHJ/yrYBMS3ATSMm+ZzM/WLs4gyTTJw2jRTEFL5+gphSYSeYdKpGgJcOtd0jTA+Ly5NL6TeyfSKj25daCRGL+FwQqRyKpGI9D7qsn/uRzc4oV9BoqcU8P6SIBUcWQpq/YrhrU7dpbQNyl8+ZrjckWff5kjMEa6F/n923b0BMWnHDnB/kaxMP1MvxWdDXLnksSqlcQExBcNtfgsZkx8hUwmWxCK5duLBcmvR4gfePj+bXHzezoN2k59eqvrSguSVzHdaHxtmU3K1a0xJwI9KceQPiEilGwLZBxCSHIKqW/kXeYJk1sVTBrE3RXNK09yUsJFGMz9q4uGrCy9hC3CDyQ4nmphYobjs1ObmeW8znVVpyektefkdG02Q6OTSLmMqzJt6Q2KI4+KwYevPolVwbREwSedjOgmyIyKSnaP7d0s6/NERhjn+Zpj0Qk21+BP2+kSGJgkay8JJDiKfyY2LThSFuXXAf3DSl1erTEIT93CBNuzy6ZhET9yguOTmYahtETFIIIpv3nMunIJvIDWZkY0gilxbNZaAxQWMKnkHpFkTqkgMxzTteRoU4ibCTfqtUd+B8YVMHXKlNc1+qkuUnMkMdO50ZpJND84jpmpw4/l0VjN1k3RTnB/kO1voVgpCPWjbn6UMUpdFgoDFpI0XDlOc2rdMtiH7ExL0tDrmnlPZADehfvmdPL4gEzpxIwA2ZeaBfzhMkxWfT1faR/uczMp2cWb0K52+nk0Mzielq3IX7N//4EFSJ7+l46CTKxhCTcI5Y1Yw3B8JmztOFKAIxOU0j/0JwfvDH7GphYHfpL/ST4rlBt84dQ82sNl/uLg8LT7c807lffyathty8ZyO1d+PcmQBChlkSJnnecT/IA0/7kKcepzjJu+dBYy7Gm0AOndlnrUdiqvYKbALkPpe3yggHLcYT2niQVyQ5zPzlr+ze7/4Ui/UXgwt/QF8XWy5IT/PocC9MmB29I0fMOezbjmkM7gjrS56+H2l/kaK9LMvh/FBVYLr3N3XGlGIsqBMIAAEgUDMCIKYUgIOYUqCKOoEAENgRBEBMKQQNYkqBKuoEAkBgRxAAMaUQNIgpBaqoEwgAgR1BAMSUQtAgphSook4gAAR2BAEQUwpBg5hSoIo6gQAQ2BEEQEwpBA1iSoEq6gQCQGBHEAAxpRA0iCkFqqgTCACBHUEAxJRC0CCmFKiiTiAABHYEARBTCkGDmFKgijqBABDYEQRATCkEDWJKgSrqBAJAYEcQADGlEDSIKQWqu1nno956QFQpm/BuooRRbxkCIKYUAt0UMZVh8h+HDymn4KWdCaUWpyjWgQFbVxsvA3r+bOxTln9UL99z1O9qT4l5HljJhF6lwKIUvPXlmNIveD79u/9O7/5R+9Zs9mf16n//x7nGMmjnfWt691x9LiKwq5zyQxkCbJoafXT3GQWx1Ud8Px3fc+7rmqyF+deZPvUO2BrcEbzYdgRATCkkuDFiipjSO6do3x1KR/Dy3YtKEJW5mX6S6+h+V5kIY4X75wVfqaG62f3ROco5E5PK/qwdYz77oxMxMYHn05+IbI688c6JoLLuU2cMtfPzslVbihmpc2K6j/yeN4F6A4EXtgUBEFMKSW4DMV3jMlJVdrv93q9U1b4Is2/adF1lsYhpXnepkdBi75AnqCoxsZY07b6h9vRpFFzmqFd/Nck4522AmFzQRpnECICYUgC8XcTEBrLPqju9522KKdNuf7BCzNrZq3d3rOXE3XqilNKsPZ2On4h9q0JMMUhpqXMOmgk0pkpTDS+nRwDElALjbSMmxqjYkXfvOJuL+J3yLON7J4g70zvexLdYcWyNaanTlrTyVYjJRaN0AvCykIucQEw+iKLsBhAAMaUAvZnExCms+fzE9Likwx6R9uB+OP6w95uzeapqOuqkxMSQCedgocRkP3+7oIbp/IiyvSpFTilXWXdtsnpNcjKfVYGYUnz1qDMiAiCmiGBeVdVIYnIw8TzqHZFmdELj0HtsFQN0qKfQloq6fvGAl1K3j7/zKL9c1ExM5GE4PjTWe5VqXbFnoHnBl4gzlJgeHnwo0s3rH9pIdI+0GmqRzjojjzz1tRkviUhxxhQ8z/BiLQiAmFLA3FZiYix4of7bdCSQE7knjwdW2Pq9IZXxc13P1ANy1+YF1/8JJabFlqQ+s4ns1fiWtmOhxCRqeZYNgJ34nxgdN6Ax+c8vvFErAiCmFHC3mZgYj3JH/sYAjV2zKcntN8P7r+n/3zf8zo30dC/HIKay3xOq3qCJGMgihJhkjBWRSmadmv0em/j02q2o4UFjsmKLAhtFAMSUAv62E1NBTj0+j9Iv0LZFs7zoq79Uy04Os+6JlpxYK7lJJqjhSDoL00ssBjGV4x7Sn3pNz6TRxScmO/lzX8szKv1ZUpafGy8uQ2NK8dWjzogIgJgignlV1XYQ04jGoz9zsXnQ9XusbR1qoP1EmsA+Lf5m4lLKbIKSZBWNmKRLygbvvPjEpNRe91YQQbvMZxCTC0oos0EEQEwpwN9lYipDEPGl2vVn0bxk1shkjzKTvGIRk+gpF5OYBJzKMdrvT4XOXRBTKHJ4ryYEQEwpgN4OYpoQNN9q4ZFMedLCvqhpic4RASGKYhGTFFYnpimPge33zBjPyWmPQg2FmDZl7XJEv9ZrwzYzrVivpG06enOm+B5RZ+sQADGlEFnbiUnSepS6IHOcOXSO+cJoacabP5JXWUiIomjEJDgUmEyYIaa8gpgcYhsWF2bzZ0rdIMeQWIF14fyQ4rNHnfEQADHFw/K6ptYTU49dtv0958QQRBozmMmcFxKiKAYxyS7Yy8S6OG9CicnqBbgyORkXNvFlHTJ3ViApyZSXac8G3b6SXA2oIP9oHmhMbiCiFCMAYkoxD9pKTOVCyZHADYsLgyUsML7mOam8zcFiVW5ViYlJaUaehKZAqpIWF0pMhdbkcllWO0kpRUk2VF8RSfma+iRiSvE9FHWCmJJBu4UVg5hSCLWJxJRnx6pDLsSrz4zC3GQzMs1llHaBXI/lCNcfyRxnilSglDkEkf490ZyXP/fK02QipiJ9R76e72lGkbw56kKe0d+Fy/W+MBUuyEtu30gAVYiJGy01zRH9lxDJwdC7ualv78ZzZ4ICMaX46lFnRARATBHBvKqqicQUY5ySFhN6ZmR2AHC7yzMfV8pYebaIFFWJicdQaqt0luQZLWM+fiaoDrnau0TOADHF+BpQR0IEQEwpwN1OYpLvF/WlcynBy06KQG4jhEXZpSEmDqJ6bM3JFIOYrgi2cCM/oX+yFuevQbm4mYOYUnz1qDMiAiCmiGBuqcZ0QaaugbgTl0MQyeY/OWeTe4ii+MT0kRIkDpxSccQkpvkkKjFlcuIfkyOKafbKd6BATCm+etQZEQEQU0Qwt5CYXtDZyrH17KJqJAeTOc8nRFE8YvpEcjyxaklL2lqE1OrSPLwmqQEVs6W8KGuStE1csE3x1aPOiAiAmCKCuQXExIvyOS1qI5V3z5xdkqX0DS6hdeSEgm4hiszERGMi77XFh509TAkMfchwXmcKjck0L8s7ZnwWZdOizGd0IKYUXz3qjIgAiCkimM0mpkTuuvJl3BjouiUn9HUXF6MuWDLWro6qTmKat106mzDhms+hjBeCccE2xsREHekQADGlwLaRzg+piMkhekFljB1CFPkT04C6pY+A7qs1bYKYGFNbTibT3StoTJVnJCpIiwCIKQW+O0VMPQ7YSualhI9LiCJfYuLuxtKaQojpUc98VvRy/NYZTSknkzIFnYXG5IwvCm4EARBTCth3hZhkj7qYyNrvNIURUxytKYSYqmSvXURWjLYBYoo5CVFXfQiAmFJgvSvEFJI+PRRvW4iiEGKyxqpzPGsKI6YJQaGP3u6iIc5xFO+PgZhCpxve2ywCIKYU+O8KMZlDENHF1FyfWVXCm0MDmbzlpFThpVkuN1T9lly/D43NShG+Xc+awohJCpQ7ITf9O1Y3/XLcginVlAoeprwUnz3qjIcAiCkeltc17QIxyQfv7hdjl8xSQvI8JolX41tmggkkphhaUxgxmc2IPMhcnVGa+SciOfV77LzB9egfk6s+nB9SfPWoMyICIKaIYF5VtQvEJJmQfEIJreIvHebLl0bDNCZuX7pH5aI1hRCTlRCZnDgArXqmXr57sQQTn+1Nuz9cBp81zWDz5gDElOKrR50REQAxRQRzZ4hJDkEkJxK04S1HkZAW23Bist7Fspw1hRAT4yCPdRWpCREVJw00R3dffEM6kwMx2WYhfr9hBEBMKQSw7RpTKHm4YC2TnqKzl1ta81boGdO8T5Ijh01rCiWmkpyG9OdjF2jcy9iIFGdM7lii5CYQMBDTJroitHk6zsQelcnW3jSs1yvdcfTwqjIIMVV3xAu2Uggim/ecy/hETzNK7XA65sV8+alMTML5VtGSIL8qxBSfnOzne9CYXGYhymwQARBTbeBvCTHJZi9z+nEfnGWNTB+iqCox2QhC0pqqElPRduUIGm4pOspxjuhP/QVf2yZQkmNdGyOfuYSyrUQAxFSb2LaFmIQF1ObS7Yq1zZynNCGKohCTTfM23QuKFF2cST/7ckxnSQOCyjUXExMSuZ53KSL6aOIEMYjJCSYU2hwCIKbasK+DmNgc9YV+NM/ejXOnezFHPGrfAAAAjklEQVQ2PIpoDx1KxZ6wDa7at53CnKt5OrPPTjmV5q+a6uHfm+r654MDEbb/fPfOBuva74t+dOgnZ3lqZJqNyBHiXH1FKdmHo89e9UvYnr4fedW1WLjQphPPv+DO4cU2IUDEdPAfje/w6bt/Ffv4L3f/Qf1f598aPY589l/q1fv/bnQf0TkgAASAQAMQ+H9086+Jy02B/gAAAABJRU5ErkJggg==');
}

.is-tablet .foot-logo {
    grid-column: span 2;
}

.is-mobile .foot-logo {
    grid-column: span 4;
    background-position: 50% 50%;
}

.foot-people {
    padding-top: 20px;
    color: #45464B;
    font-size: 14px;
    line-height: 24px;
    order: 2;
    font-weight: 500;
    font-family: "Montserrat", sans-serif;
}

.foot-people b,
.foot-people em {
    font-weight: 700;
}

.is-tablet .foot-people {
    grid-column: span 2;
    order: 3;
}

.is-mobile .foot-people {
    grid-column: span 4;
    order: 3;
    font-size: 13px;
    margin-top: 40px;
}

.foot-address {
    grid-column: span 2;
    padding-top: 20px;
    grid-gap: 20px;
    display: flex;
    order: 3;
    justify-content: flex-end;
}

.is-tablet .foot-address {
    order: 2;
    padding-top: 0px;
    grid-gap: 0px;
    grid-row: span 2;
    flex-direction: column;
    justify-content: flex-start;
}

.is-mobile .foot-address {
    order: 4;
    grid-column: span 4;
    padding-top: 0px;
    grid-gap: 0px;
    flex-direction: column;
    justify-content: flex-start;
}

.foot-address-item {
    width: 215px;
    padding-left: 20px;
    color: #45464B;
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    font-family: "Montserrat", sans-serif;
}

.foot-address-item:first-child {
    margin-top: 0px;
}

.is-tablet .foot-address-item {
    margin-top: 20px;
    width: 100%;
}

.is-mobile .foot-address-item {
    font-size: 13px;
    margin-top: 20px;
    width: 100%;
}

.is-mobile .foot-address-item >>> br {
    display: none;
}

.is-mobile .foot-address-item >>> br:first-of-type {
    display: inline-block;
}

.foot-address-item:before {
    content: '';
    display: block;
    width: 4px;
    height: 25px;
    background-color: #F0C994;
    position: absolute;
    left: 0px;
    top: 0px;
}

.foot-address-item b,
.foot-address-item em {
    font-weight: 700;
}

.foot-logo.is-coe {
    margin-top: 64px;
    background-size: auto 38px;
    height: 38px;
    order: 4;
    background-position: 0px 0px;
    background-repeat: no-repeat;
    background-image: url('data:image/png;base64,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');
}

.is-tablet .foot-logo.is-coe {
    margin-top: 32px;
}

.is-mobile .foot-logo.is-coe {
    grid-column: span 4;
    background-position: 50% 50%;
    order: 2;
    margin-top: 40px;
}

.foot-contact {
    grid-column: 2 / span 3;
    margin-top: 64px;
    order: 5;
}

.is-tablet .foot-contact {
    grid-column: span 2;
    margin-top: 32px;
}

.is-mobile .foot-contact {
    grid-column: span 4;
    margin-top: 20px;
}

.foot-contact-item {
    color: #45464B;
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    font-family: "Montserrat", sans-serif;
    background-position: 0px 50%;
    padding-left: 32px;
    background-repeat: no-repeat;
}

.is-mobile .foot-contact-item {
    font-size: 13px;
}

.foot-contact-item.is-phone {
    background-size: 14px 20px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAoBAMAAAAfyIccAAAAGFBMVEUAAAAAWEAAVz0AWD0AWD0AWD0AVz0AWD0ndUPjAAAAB3RSTlMAIPCw4N+v7qVGoAAAAD9JREFUKM9jYEwth4MwAQahciSgyGCOzC1mUEfmljKUlzPAAJA9yqUpF0iSxKXcXtToLkFLDOhJhdEEwXMWAABWTW5CYc5gLgAAAABJRU5ErkJggg==');
}

.foot-contact-item.is-email {
    background-size: 16px auto;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAaCAMAAADhRa4NAAAAOVBMVEUAAAAAWD4AWD0AYEAAWDwAVz0AWDwAWD0AWjoAWD0AWEAAVz4AWD0AWD0AWD0AWT0AWD0AWD0AWD0Sxj7jAAAAEnRSTlMAgOAQQPCQcDBgIM/AsKBQ0J/xOJMRAAAAjklEQVQoz+WQSw7DIAxEH/+QD0l9/8OWRS1UN+ECHQkvmCfPABQvj9oKFJnqxM+BnT5yujd97oN+Ymh3fg5RAYg/SdcCCjgA92WnAqARsnWadR/+saJb0Tygpk+5EwgvEQXGZTNwF3btZeKwxUZhA2hZ+2Ts52g5C6h8EgtY/SXgOeZAY0nTBQFCdY+qgTdsEzFqBVfnfwAAAABJRU5ErkJggg==');
}

.foot-links {
    grid-column: 2 / span 3;
    display: flex;
    margin-top: 24px;
    order: 6;
}

.is-tablet .foot-links {
    grid-column: span 4;
}

.is-mobile .foot-links {
    grid-column: span 4;
    flex-wrap: wrap;
}

.foot-links-item {
    color: #45464B;
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    font-family: "Montserrat", sans-serif;
    padding: 0px 10px;
}

.foot-links-item:after {
    content: '';
    display: block;
    position: absolute;
    right: 0px;
    width: 1px;
    height: 14px;
    top: 50%;
    margin-top: -7px;
    background-color: #45464B;
}

.foot-links-item:last-child:after {
    display: none;
}

.foot-links-item:first-child {
    padding-left: 0px;
}

.is-mobile .foot-links-item {
    padding-left: 0px;
    margin-right: 10px;
    font-size: 13px;
}

.foot-legal {
    margin-top: 24px;
    grid-column: 2 / span 3;
    color: #45464B;
    font-size: 14px;
    line-height: 24px;
    order: 7;
    font-weight: 400;
    font-family: "Montserrat", sans-serif;
}

.is-tablet .foot-legal {
    grid-column: span 4;
}

.is-mobile .foot-legal {
    grid-column: span 4;
    font-size: 10px;
}

.foot-updated {
    font-size: 14px;
    font-family: "Montserrat", sans-serif;
    line-height: 24px;
    padding: 20px;
    color: #666;
    order: 8;
}

.is-mobile .foot-updated {
    font-size: 10px;
    grid-column: span 4;
}

</style>